import { useEffect } from "react";
import { ROUTES, SITE_URL, useLang } from "@/i18n";
import { JsonLd } from "@/components/site/JsonLd";
import { webPageSchema } from "@/data/structuredData";

const OG_IMAGE = `${SITE_URL}/images/og-image.jpg`;
const OWN_SCHEMA = ["home", "about", "publications"];

export const Seo = ({ page }) => {
  const { lang, t } = useLang();
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const { title, description } = t.seo[page];
  const route = ROUTES[page];
  const url = route ? `${SITE_URL}${route[lang]}` : null;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {url && <link rel="canonical" href={url} />}
      {route && <link rel="alternate" hrefLang="en" href={`${SITE_URL}${route.en}`} />}
      {route && <link rel="alternate" hrefLang="pl" href={`${SITE_URL}${route.pl}`} />}
      {route && <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${route.en}`} />}
      <meta property="og:type" content={page === "about" ? "profile" : "website"} />
      <meta property="og:site_name" content="ONKOLIFE" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {url && <meta property="og:url" content={url} />}
      <meta property="og:locale" content={lang === "en" ? "en_US" : "pl_PL"} />
      <meta property="og:locale:alternate" content={lang === "en" ? "pl_PL" : "en_US"} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={t.home.portraitAlt} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      {!route && <meta name="robots" content="noindex" />}
      {route && !OWN_SCHEMA.includes(page) && <JsonLd data={webPageSchema(lang, page)} />}
    </>
  );
};
